'use client';

import { type ElementType, forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { VisuallyHidden } from '../visually-hidden';
import { ComboboxGroupContext } from './context/combobox-group.context';
import { comboboxHeadingStyles } from './styles/combobox-heading.styles';
import type { ComboboxHeadingPropsInterface } from './types/combobox-heading.types';

/**
 * @since 10.0.0
 */
export const ComboboxHeading = forwardRef<HTMLHeadingElement, ComboboxHeadingPropsInterface>(
  (props: ComboboxHeadingPropsInterface, forwardedRef) => {
    const { className, css: cssProp, level, visuallyHidden, ...rest } = props;
    const { id } = useContext(ComboboxGroupContext);
    const styles = css(comboboxHeadingStyles, cssProp);
    const Component: ElementType = visuallyHidden ? VisuallyHidden : `h${level}`;
    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="Combobox.Heading"
        data-c11n-version={__C11N_VERSION__}
        className={cx(
          visuallyHidden ? undefined : 'c11n',
          'c11n_combobox__heading',
          visuallyHidden ? undefined : styles,
          visuallyHidden ? undefined : className,
        )}
        id={id}
        {...rest}
      />
    );
  },
);

ComboboxHeading.displayName = 'Combobox.Heading';
